import { render, staticRenderFns } from "./CustomVuetable.vue?vue&type=template&id=7631c212&"
import script from "./CustomVuetable.vue?vue&type=script&lang=js&"
export * from "./CustomVuetable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports